import React from 'react';
import {Button, Stack, Typography} from '@mui/material';
import {IconIllustration} from 'presentation/components';
import {translations} from 'presentation/translations-new';

const {addNewAddress, emptyState, addNewAddressDescription} =
	translations['pt-br'].privateFlow.bookingFlow.location;

export function EmptyState({handleAddNewAddress}: {handleAddNewAddress: () => void}) {
	return (
		<Stack gap={2} alignItems="center" mt={6}>
			<IconIllustration variant="default" customIconName="location-on-filled" width={80} />
			<Stack alignItems="center" gap={1}>
				<Typography variant="h6" textAlign="center" color="textPrimary">
					{emptyState}
				</Typography>
				<Typography variant="body1" textAlign="center" color="textSecondary">
					{addNewAddressDescription}
				</Typography>
			</Stack>
			<Button variant="outlined" size="large" onClick={handleAddNewAddress}>
				{addNewAddress}
			</Button>
		</Stack>
	);
}
